import { PA_NAME } from "../types/product-attribute/product-attribute";

const mapBookingAttributes = (
  bookingAttributes: BookingAttributeDTO[],
): BookingAttributeRequestDTO[] => {
  return bookingAttributes
    .filter((x) => {
      const paName = x?.productAttribute?.name;
      if (!paName) return false;
      if (PA_NAME.CHECKBOX.includes(paName as ProdAttrNameSingleCheckbox)) {
        return !!x.value?.quantity;
      }
      return true;
    })
    .map((x) => ({
      productAttributeId: x.productAttribute.id!,
      value: x.value,
    }));
};

const mapBookingStateToDetailRequest = (
  booking: BookingState,
): BookingDetailRequestDTO => {
  return {
    productId: booking?.product?.id!,
    bookingAttributes: mapBookingAttributes(booking.bookingAttributes),
  };
};

export const mappingBookingState2RequestDTO = (
  booking: BookingState,
  ex?: {
    voucherId?: number;
    updateBookingMode?: boolean;
  },
): BookingRequestDTO => {
  const status = undefined;
  const baseRequest = {
    id: booking?.id ?? "",
    status,
    voucherId: ex?.voucherId,
    updateBookingMode: ex?.updateBookingMode,
    bookGroupNo: booking?.bookGroupNo,
  };

  if (booking.product?.productType === "PASS") {
    const bookingDetails =
      booking.childrenLs?.map(mapBookingStateToDetailRequest) ?? [];
    if (bookingDetails.length <= 1) {
      // 1 product thì tính là mua lẻ
      return {
        ...baseRequest,
        bookingDetails,
      };
    }
    return {
      ...baseRequest,
      bookingDetails,
      ...mapBookingStateToDetailRequest(booking),
    };
  }

  return {
    ...baseRequest,
    bookingDetails: [mapBookingStateToDetailRequest(booking)],
  };
};
